module.exports = import("/patient-components-ui/assets/remoteEntry.js");